import { createContext, createSignal, useContext, type JSX } from "solid-js"
import { type OfferingProduct } from "../../features/payment/domain/models/offering"
import {
  type OfferingType,
  type OfferingsByType,
} from "../../features/payment/domain/models/offering-type"

export interface ProductsContextType {
  readonly products: () => OfferingsByType
  readonly addNewProduct: (type: OfferingType, product: OfferingProduct) => void
}

const [products, setProducts] = createSignal<OfferingsByType>({})

const addNewProduct = (type: OfferingType, product: OfferingProduct): void => {
  setProducts((prev) => {
    return {
      ...prev,
      [type]: product,
    }
  })
}

const getProducts = (): OfferingsByType => {
  const prods = products()
  if (!prods) {
    throw new Error("Products not loaded")
  }
  return prods
}

const defaultUserContext: ProductsContextType = {
  products: getProducts,
  addNewProduct,
}

const ProductsContext = createContext<ProductsContextType>(defaultUserContext)

export const ProductsProvider = (props: { children: JSX.Element }): JSX.Element => {
  return (
    <ProductsContext.Provider value={defaultUserContext}>{props.children}</ProductsContext.Provider>
  )
}

export const useProducts = (): ProductsContextType => {
  return useContext(ProductsContext)
}
